import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
  faCircle,
  faCircleNotch,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/pro-solid-svg-icons";
import {
  faCreditCard,
  faDownload,
  faEnvelope,
  faFileSpreadsheet,
  faListUl,
  faLongArrowRight,
  faMoneyCheck,
  faMinus,
  faPencil,
  faPlus,
  faSignIn,
} from "@fortawesome/pro-regular-svg-icons";

// We are only using the user-astronaut icon
library.add(
  faCheckCircle,
  faCircle,
  faCircleNotch,
  faCreditCard,
  faDownload,
  faEnvelope,
  faFileSpreadsheet,
  faListUl,
  faLongArrowRight,
  faMinus,
  faMoneyCheck,
  faPencil,
  faPlus,
  faSignIn,
  faTimesCircle
);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch({
  autoReplaceSvgRoot: document,
  observeMutationsRoot: document,
});
